// @ts-nocheck
import * as React from "react";

const Navigation2Fill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m13.13 19.346-2.427-6.088-6.089-2.466-.038-.63 14.846-5.623-5.661 14.807h-.631Zm.304-1.969 4.28-11.13-11.169 4.242 4.9 1.988 1.989 4.9Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Navigation2Fill);
